import { mediaUrl, staticAssetUrl } from './mediaUrl'

const DEFAULT_FAVICON = staticAssetUrl('favicon.ico')
const LINK_ID = 'site-favicon'

/**
 * Update document favicon link. Falls back to the built-in favicon.ico.
 * @param {string} [path] Absolute/media path from settings, or empty for default.
 */
export function applyFavicon(path) {
  if (typeof document === 'undefined') return

  const href = mediaUrl(path) || DEFAULT_FAVICON
  let link = document.getElementById(LINK_ID)
  if (!link) {
    link = document.querySelector("link[rel='icon']")
  }
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.id = LINK_ID

  const lower = href.toLowerCase()
  if (lower.endsWith('.svg')) {
    link.type = 'image/svg+xml'
  } else if (lower.endsWith('.png')) {
    link.type = 'image/png'
  } else if (lower.endsWith('.ico')) {
    link.type = 'image/x-icon'
  } else {
    link.removeAttribute('type')
  }

  // Cache-bust so a newly uploaded favicon replaces the previous one in-tab
  const sep = href.includes('?') ? '&' : '?'
  link.href = `${href}${sep}v=${Date.now()}`
}
